import * as z from 'zod';
import { FIRST_PAGE } from '@noor/config';

/** The self-employed report pages by 30 (cpanel `PAGE_LIMIT`). */
export const SELF_EMPLOYED_PAGE_SIZE = 30;

/** Page sizes the report offers (cpanel `AgGridBottom` options). */
export const SELF_EMPLOYED_PAGE_SIZE_OPTIONS = [10, 20, 30, 50, 100] as const;

export const selfEmployedStatusFilterSchema = z.enum(['all', 'confirmed', 'unconfirmed']);
export type SelfEmployedStatusFilter = z.infer<typeof selfEmployedStatusFilterSchema>;

/** Coerced + caught: a stale or hand-edited value reads as unset. */
const optionalString = z.coerce.string().optional().catch(undefined);

/**
 * URL search-param schema of `/reports/self-employed`. Keeps cpanel's query
 * keys (`search`, `status_filter`, `start_date`, `end_date`); paging moved
 * from `limit`/`offset` to `page`/`pageSize`.
 */
export const selfEmployedListSearchSchema = z.object({
  search: optionalString,
  status_filter: selfEmployedStatusFilterSchema.catch('all').default('all'),
  /** Day window (`YYYY-MM-DD`); unset means today. */
  start_date: optionalString,
  end_date: optionalString,
  page: z.coerce.number().int().positive().catch(FIRST_PAGE).default(FIRST_PAGE),
  pageSize: z.coerce
    .number()
    .int()
    .positive()
    .catch(SELF_EMPLOYED_PAGE_SIZE)
    .default(SELF_EMPLOYED_PAGE_SIZE),
});
export type SelfEmployedListSearch = z.infer<typeof selfEmployedListSearchSchema>;
